import * as React from "react";
import sideImage from "../../../assets/sample-image.png"
import crossedEye from "../../../assets/icons/crossed-eye.svg"
import eye from "../../../assets/icons/ShowView.svg"
import classes from './Register.module.scss'
import { Field, Form, Formik } from "formik";
import { LoginFormInitialValues, RegisterFormValidation } from "../../../validations/AuthValidations";
import { Input } from "../../../components/Inputs/Input";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { UserService } from "../../../services/UserService";
import { useLoader } from "../../../customHooks/loader";

export const Register = () => {
    const loader = useLoader();

    const [passwordInput, setPasswordInput] = useState('password');
    const navigate = useNavigate();

    const handleLogin = async (values, resetForm) => {
        console.log({ values });
        try {
            const res = await UserService.register(values, loader);

            const { success } = res;

            if (success) {
                console.log({ first: res.data.user })
                navigate('/login')
                toast.success('Registered Successfully');
            }
        } catch (error) {
            console.error(error);
        }
    }
    return (
        <>
            <div className={classes.parentContainer}>
                <img
                    src={sideImage}
                    alt="decorator"
                    className={classes.sideImage}
                />

                <div className={classes.div}>
                    <div className={classes.div2}>Get Started Now</div>
                    <div className={classes.titleDescription}>Sign up for free to access to in any of our products </div>
                    <Formik
                        enableReinitialize
                        initialValues={LoginFormInitialValues}
                        validationSchema={RegisterFormValidation}
                        onSubmit={(val, { resetForm }) => handleLogin(val, resetForm)}
                    >
                        {({ errors, touched, values, isValidating, handleSubmit, ...props }) => {
                            return (
                                <Form>
                                    <div>
                                        <div className={classes.div3}>
                                            <Input name='fullName' type='text' placeholder='' labelClassName={classes.div3} className={classes.InputStyle} label='Full Name' required />
                                        </div>
                                        <div className={classes.div3}>
                                            <Input name='email' type='email' placeholder='' label='Email address' required labelClassName={classes.div3} className={classes.InputStyle} />
                                        </div>
                                        <div className={classes.div3}>
                                            <Input name='phone' type='phone' placeholder='' label='Phone Number' required labelClassName={classes.div3} className={classes.InputStyle} />
                                        </div>
                                        <div className={classes.div3}>
                                            <div className={classes.div11}>
                                                <label className={classes.div6} htmlFor='password'>Password</label>

                                                <div className={classes.div4}>
                                                    {passwordInput === 'password' ? (
                                                        <>
                                                            <img
                                                                className={classes.img}
                                                                src={eye}
                                                                alt="hidden password"
                                                                onClick={() => setPasswordInput('text')}
                                                            />
                                                        </>
                                                    ) : (
                                                        <div>
                                                            <img
                                                                className={classes.img}
                                                                src={crossedEye}
                                                                onClick={() => setPasswordInput('password')}
                                                                alt="unhidden password"
                                                            />
                                                        </div>
                                                    )}

                                                </div>


                                            </div>
                                            <Field
                                                className={classes.InputStyle}
                                                type={passwordInput}
                                                name='password'
                                                id='password'
                                                placeholder='Password'
                                            />
                                            {/* <div className={classes.titleDescription}>Use 8 or more characters with a mix of letters, numbers & symbols</div> */}
                                            <div className={classes.agreement}>
                                                <input type="checkbox" id="vehicle1" name="vehicle1" value="Bike" />
                                                <div className={classes.agreementText}>
                                                    Agree to our Terms of use and Privacy Policy
                                                </div>
                                            </div>
                                            <div className={classes.agreement} style={{ marginTop: "1vw" }}>
                                                <input type="checkbox" id="vehicle1" name="vehicle1" value="Bike" />
                                                <div className={classes.agreementText}>
                                                    Subscribe to our monthly newsletter
                                                </div>
                                            </div>

                                            {errors.password && touched.password ? (
                                                <div className='error'>{errors.password}</div>
                                            ) : null}
                                        </div>
                                        <button type="submit" className={classes.div10}>Sign Up</button>
                                    </div>
                                </Form>
                            )
                        }}
                    </Formik>
                    <div className={classes.div12}>Already have an account? <span onClick={() => navigate('/login')}>Log In</span> </div>
                </div>
            </div>
        </>
    );
}
